<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <div class="ui form" [formGroup]="projectForm">
      <div class="field" [ngClass]="displayFieldCss('role')">
        <label>Roles</label>
        <sui-select
          class="selection"
          formControlName="role"
          [options]="options"
          [isSearchable]="true"
          #select
        >
          <sui-select-option
            *ngFor="let option of select.filteredOptions"
            [value]="option"
          >
          </sui-select-option>
        </sui-select>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="!projectForm.valid"
    (click)="submit()"
    autofocus
  >
    Done
  </button>
</div>
<!-- <div class="padding">
  <sui-message class="success" *ngIf="success">
    <div class="header">
      {{ success }}
    </div>
  </sui-message>
  <sui-message class="warning" *ngIf="error">
    <div class="header">
      {{ error | json }}
    </div>
  </sui-message>
  <div class="ui form" [formGroup]="projectForm">
    <div class="field" [ngClass]="displayFieldCss('role')">
      <label>Roles</label>
      <sui-select
        class="selection"
        formControlName="role"
        [options]="options"
        [isSearchable]="true"
        #select
      >
        <sui-select-option
          *ngFor="let option of select.filteredOptions"
          [value]="option"
        >
        </sui-select-option>
      </sui-select>
    </div>
  </div>
  <div class="actions">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Cancel
    </button>
    <button
      class="ui primary button"
      *ngIf="show"
      [ngClass]="{ yellow: pending }"
      [disabled]="!projectForm.valid"
      (click)="submit()"
      autofocus
    >
      Done
    </button>
  </div>
</div> -->
